export default __webpack_public_path__ + "static/media/bg2.85f6bf4c.png";